import React from "react";
import CheckClientInfo from "../../screens/auth/CheckClientInfo";
import { MockedProvider } from "@apollo/client/testing/react";
import type { Meta, StoryObj } from "@storybook/react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { StoryStackNavigatorContainer } from "../display-helpers";

const Stack = createNativeStackNavigator<{
    CheckClientInfo: undefined;
}>();

const StoryComponent = () => {
    return (
        <MockedProvider mocks={[]}>
            <StoryStackNavigatorContainer>
                <Stack.Navigator initialRouteName="CheckClientInfo">
                    <Stack.Screen name="CheckClientInfo" component={CheckClientInfo} />
                </Stack.Navigator>
            </StoryStackNavigatorContainer>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/Check client info",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
